import Image from 'app/Components/Shared/Image/image';
import React, { useState } from 'react';
import PopUp from '../../../../Shared/Popup/PopUp';
import mapImage from './images/paving-fee-map.svg';
import ReactTooltip from 'react-tooltip';

const PavingFee = (props) => {
    const [isDisplayPopup, setIsDisplayPopup] = useState(false);

    return (
        <div className='paving-fee'>

            <div className='map-wrapper'>
                <Image src={mapImage} alt='' />
            </div>

            {/* <div className='remark-wrapper'>
                <div className='remark-link' data-tip data-for="paving-fee-info" data-event='click'>מחוברים לסיבים? <span>אתם יכולים לקבל זיכוי <span className='more-info'></span></span></div>
            </div>

            <ReactTooltip id='paving-fee-info' aria-haspopup='true' role='example' backgroundColor='#ffffff' place='top' effect='solid'>
                <div className='tooltip-wrapper'>
                    <div dangerouslySetInnerHTML={{ __html: props.pavingFeeTooltipText }}></div>
                </div>
            </ReactTooltip> */}

            {
                props.pavingFeePopupText &&
                <div className='open-popup-link-wrapper'>
                    <div className='open-popup-link'><a href='#' onClick={() => handleIsDisplayPopup(true)}>יש לך כבר פריסת סיב פעיל בדירה?</a></div>

                    <PopUp showPopUp={isDisplayPopup} onClose={() => handleIsDisplayPopup(false)} footerBtn={{ text: 'חזרה', onBtnClick: handleClosePopup }}>
                        <div dangerouslySetInnerHTML={{ __html: props.pavingFeePopupText }}></div>
                    </PopUp>
                </div>
            }

        </div>
    );

    function handleIsDisplayPopup(isShowPopup) {
        setIsDisplayPopup(isShowPopup);
        if (isShowPopup) {
            props.onOpenPopup();
        }
    }

    function handleClosePopup() {
        setIsDisplayPopup(false);
    }

};
export default PavingFee;